import script from "./ESportsCoupons.vue?vue&type=script&setup=true&lang=js"
export * from "./ESportsCoupons.vue?vue&type=script&setup=true&lang=js"

import "./ESportsCoupons.vue?vue&type=style&index=0&id=6a528321&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a528321"]])

export default __exports__